<form [formGroup]="formGroup" *ngIf="formGroup">
    <div class="form-group row">
        <label class="col-md-3 col-form-label">Nombre</label>
        <div class="col-md-9">
            <input type="text" formControlName="name" class="form-control" />
        </div>
    </div>
    <div class="form-group row">
        <label class="col-md-3 col-form-label">Descripción</label>
        <div class="col-md-9">
          <textarea rows="9" class="form-control" placeholder="Descripción breve..." formControlName="description"></textarea>
        </div>
    </div>
    <div class="form-group row">
        <label class="col-md-3 col-form-label">¿Activo?</label>
        <div class="col-md-9">
            <label class="switch switch-label switch-pill switch-primary">
                <input type="checkbox" formControlName="active" class="switch-input" checked>
                <span class="switch-slider" data-checked="Si" data-unchecked="No"></span>
            </label>
        </div>
    </div>
</form>

<div class="modal-footer">
    <button class="btn btn-success" (click)="submit()" [disabled]="!formGroup.valid"><i class="fa fa-save"></i> Guardar</button>
    <button class="btn btn-danger" (click)="modalRef.hide()"><i class="fa fa-times"></i> Cancelar</button>
</div>